import { render, staticRenderFns } from "./BranchAvailability.vue?vue&type=template&id=5aff9d14&scoped=true&"
import script from "./BranchAvailability.vue?vue&type=script&lang=js&"
export * from "./BranchAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aff9d14",
  null
  
)

export default component.exports